<script>
    import { onMount } from "svelte";
    import moment from 'moment';
    import { ModalBody, ModalFooter, ModalHeader, Modal, Label } from "sveltestrap";
    import backend from "../../../../../server";

    export let showDetalls = false;  
    export let offerId; 
   
    let isLoading=false; 
    let details={};
    let filter = { accountId: 431, offerId: offerId};
 
    onMount(async () => {
        details={};
        
        if (!filter.offerId) {
        console.error("Error: campaignId o playerId no definidos");
        return;
        }
        await getDetailCampaignByOfferId();
     });
   const getDetailCampaignByOfferId = async()=>{
    try {
        const params = {  ...filter };
        details={}
        isLoading=true
        let response = await backend.freespin.getDetailByOfferId(params);
        details = response.data.info;
         
    
    } catch (error) {
      console.log("ERROR:" ,error.messenger)
    }
    isLoading=false
   }
   const closeModal = () => {
    showDetalls = false;
    };


  // Formatear fecha con Moment.js
  const formatDate = (datetime) => {
    if (!datetime) return 'N/A';
    return moment(datetime).format('DD/MM/YYYY HH:mm:ss');
  };


</script>
<Modal isOpen={showDetalls} size="xl">
    <ModalHeader>
      DETALLES DE FREESPIN:
    </ModalHeader>
    <ModalBody>
      <div class="freeSpin-modal">
        {#if isLoading}
          <!-- Muestra un spinner o algún indicador de carga mientras esperas la respuesta -->
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        {:else if details.id}
          <!-- Mostrar detalles en columnas y agrupados -->
          <div class="row">
            <!-- Columna 1 -->
            <div class="col-md-6">
              <div class="mb-3">
                <strong>ID:</strong> {details.id}
              </div>
              <div class="mb-3">
                <strong>ID de Oferta:</strong> {details.offerId}
              </div>
              <div class="mb-3">
                <strong>Fecha de Creación:</strong> {new Date(details.createdAt.date).toLocaleString()}
              </div>
              <div class="mb-3">
                <strong>Giros restantes:</strong> {details.remaining}
              </div>
            </div>
            
            <!-- Columna 2 -->
            <div class="col-md-6">
              <div class="mb-3">
                <strong>Fecha de Expiración:</strong> {new Date(details.expireAt.date).toLocaleString()}
              </div>
              <div class="mb-3">
                <strong>Conteo Total:</strong> {details.totalCount}
              </div>
              <div class="mb-3">
                <strong>Suma Ganada:</strong> {details.winSum}
              </div>
              <div class="mb-3">
                <strong>Está Activo:</strong> {details.isActive ? 'Sí' : 'No'}
              </div>
            </div>
          </div>
        {:else}
          <!-- Si no se encontraron detalles, mostrar un mensaje -->
          <div class="alert alert-warning mt-4">
            <i class="fas fa-exclamation-triangle me-2"></i>
            No se han encontrado detalles para la campaña y jugador especificados.
          </div>
        {/if}
      </div>
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-secondary" on:click={closeModal}>
        Cerrar
      </button>
    </ModalFooter>
  </Modal>
  

<style>


</style>